import React, { ChangeEvent, useRef } from 'react';

interface VideoInputProps {
  accept?: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  isLoading?:boolean;
  width?:string;
  height?:string;
}

const InputVideo: React.FC<VideoInputProps> = ({ accept = 'video/*', onChange,width,height, inputProps ,isLoading}) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleClick = () => {
    fileInputRef.current?.click(); // Trigger the hidden file input
  };

  return (
    <div className="flex items-center ">
      <button
        type="button"
        className={`px-4 py-2 rounded-lg text-gray-500  bg-slate-100 ${width?width:'w-44'} ${height ? height:'w-44 h-[100px] '}`}
        onClick={handleClick}
      >
        {isLoading ?  <p className='text-sm'>Uploading...</p>:
          <p
          className={`text-gray-300 text-center ${
          isLoading?"text-sm":"text-3xl"
          }`}
        >
          +
        </p>
        }
      </button>
      <input
        type="file"
        accept={accept}
        onChange={onChange}
        ref={fileInputRef}
        className="hidden"
        {...inputProps}
        
      />
    </div>
  );
};

export default InputVideo;
